module.exports = __webpack_public_path__ + "media/images/icon/top-9b6a64fcf1d1ac083a165b3340155998.png";